import * as React from 'react'

import { LucideIcon } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import { Kbd } from '~/client/src/shared/components/shadcn-ui/kbd'
import {
  Tooltip,
  TooltipTrigger,
} from '~/client/src/shared/components/shadcn-ui/tooltip'

import { MarkupTooltipContent as TooltipContent } from './MarkupPortalContainer'

export interface IProps {
  icon: LucideIcon
  label: string
  /** Keyboard shortcut hint appended to the tooltip, e.g. "Cmd+Z". */
  shortcut?: string
  isActive?: boolean
  disabled?: boolean
  onClick: () => void
}

// Canonical ghost icon button; selected state uses the primary @ 8% tint from
// the design tokens. Sizing (button + glyph) is left to the shadcn primitive.
const MarkupToolButton: React.FC<IProps> = ({
  icon: Icon,
  label,
  shortcut,
  isActive = false,
  disabled = false,
  onClick,
}) => {
  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Button
            type="button"
            variant="ghost"
            size="icon"
            onClick={onClick}
            disabled={disabled}
            aria-label={label}
            aria-pressed={isActive}
            className={
              isActive
                ? 'tw:bg-primary/8 tw:text-primary tw:hover:bg-primary/8'
                : 'tw:text-foreground'
            }
          />
        }
      >
        <Icon aria-hidden="true" />
      </TooltipTrigger>
      <TooltipContent>
        {label}
        {shortcut && <Kbd>{shortcut}</Kbd>}
      </TooltipContent>
    </Tooltip>
  )
}

export default MarkupToolButton
